import "./faq-section.scss";

const getFaqQustions$ = () => document.querySelectorAll(".js-jiffytransfers-landing-v2-faq-link");

const SHOWN_CLASS = "jiffytransfers-landing-v2-faq-section__faq-item--shown";

document.addEventListener("DOMContentLoaded", () => {
  getFaqQustions$().forEach(faqQuestion => {
    faqQuestion.addEventListener("click", () => {
      faqQuestion.parentElement?.parentElement?.classList.toggle(SHOWN_CLASS);
    });
  });
});
